import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { ApiService } from '../../../shared/api';
import { TextConstantsService } from 'src/app/shared/text-constants';

@Component({
  selector: 'date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss'],
})
export class DateSelectorComponent implements OnInit {
  @ViewChild('datePicker', { static: true, read: ElementRef }) datePicker!: ElementRef;
  @Input () startDate;
  @Input () endDate;

  @Output() startDateChange = new EventEmitter<any>();
  @Output() endDateChange = new EventEmitter<any>();

  @Output() onChange = new EventEmitter<any>();


  showEndDate: boolean = false;
  showDate: boolean = false;

  private hoverListeners: Array<() => void> = [];

  constructor(
    private api: ApiService,
    public tc: TextConstantsService
  ) { }

  ngOnInit() {
  }
  
  
  removeHoverListeners() {
    this.hoverListeners.forEach(removeListener => removeListener());
    this.hoverListeners = [];
  }

  removeHighlight(days: Element[], startIndex: number) {
    if (startIndex === -1) {
      return;
    }
    days.forEach((day: HTMLElement) => {
      day.style.backgroundColor = 'transparent';
      day.style.borderRadius = '0';
    });
  }
  
  highlightRange(days: Element[], startIndex: number, endIndex: number) {
    if (startIndex === -1) {
      return;
    }
  
    const [from, to] = startIndex < endIndex ? [startIndex, endIndex] : [endIndex, startIndex];
    for (let i = from; i <= to; i++) {
      (days[i] as HTMLElement).style.backgroundColor = '#f3f3f3';
      if (i === from) {
        (days[i] as HTMLElement).style.borderRadius = '55px 0px 0 55px';
      } 
      if (i === to) {
        (days[i] as HTMLElement).style.borderRadius = '0 55px 55px 0';
      } 
    }
  }

  addHoverEffect() {
    const shadowRoot = (this.datePicker.nativeElement as HTMLElement).shadowRoot;
    if (shadowRoot) {
      const days = Array.from(shadowRoot.querySelectorAll('.calendar-day'));
      const activeIndex = days.findIndex(day => day.classList?.contains('calendar-day-active')) || 0;
  
      this.hoverListeners = days.map((day: Element, index: number) => {
        const mouseOverListener = () => this.highlightRange(days, activeIndex, index);
        const mouseOutListener = () => this.removeHighlight(days, activeIndex);
  
        day.addEventListener('mouseover', mouseOverListener);
        day.addEventListener('mouseout', mouseOutListener);
  
        return () => {
          day.removeEventListener('mouseover', mouseOverListener);
          day.removeEventListener('mouseout', mouseOutListener);
        };
      });
    }
  }

  dateChange(event: Event) {
    const customEvent = event as CustomEvent;
    const dates = customEvent.detail.value;

    if (dates.length === 1) {
      this.startDate = dates[0];
      this.startDateChange.emit(this.startDate);

      this.showEndDate = true;

      setTimeout((_this) => {
        _this.addHoverEffect();
      }, 500, this); // Zeit zum Laden der Tagelemente, je nach Renderzeit eventuell anpassen

    } else if (dates.length === 2) {
      this.endDate = dates[1];
      this.endDateChange.emit(this.endDate);

      this.showDate = false;

      this.removeHoverListeners();
      
      if(this.endDate < this.startDate) {
        let endDate = this.endDate;
        let startDate = this.startDate;

        this.endDate = startDate;
        this.startDate = endDate;

        this.startDateChange.emit(this.startDate);
        this.endDateChange.emit(this.endDate);
      }
    } else if (dates.length > 2) {
      const shadowRoot = (this.datePicker.nativeElement as HTMLElement).shadowRoot;
      const days = Array.from(shadowRoot.querySelectorAll('.calendar-day'));

      this.startDate = dates[2];
      this.startDateChange.emit(this.startDate);

      this.endDate = null;
      this.endDateChange.emit(this.endDate);

      this.datePicker.nativeElement.value = [this.startDate];

      this.removeHighlight(days, 0);

    }

    this.onChange.emit();
  }
}
